module.exports = __webpack_public_path__ + "media/Sport.63e197dd.svg";